import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Moment from 'moment';
import 'moment/locale/fi';

import fi from './locales/fi';
import en from './locales/en';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fi: { translation: fi },
            en: { translation: en },
        },
        fallbackLng: 'fi',
        supportedLngs: ['fi', 'en'],
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        interpolation: {
            // React already escapes interpolated values.
            escapeValue: false,
        },
    });

// Keep moment's locale (date formatting) in sync with the UI language.
Moment.locale(i18n.resolvedLanguage || i18n.language || 'fi');
i18n.on('languageChanged', (lng) => Moment.locale(lng));

export default i18n;
